import { useEffect, useRef, useState } from 'react';

const stats = [
  {
    value: '42:1',
    label: 'Average ROAS on Hotel Management Service Engagements',
    isStatic: true,
  },
  {
    value: '$1M+',
    label: 'Avg. Deal Value — Performance Contracts',
    isStatic: true,
  },
  {
    value: '18–22%',
    label: 'YoY Growth in Hotel Management Service Pipeline',
    isStatic: true,
  },
  {
    value: '$0',
    label: 'First Consultation at No Cost',
    isStatic: true,
  },
];

export default function StatsStrip() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-gray-950 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden">
          {stats.map((stat, i) => (
            <div
              key={i}
              className={`bg-gray-950 px-8 py-10 flex flex-col items-center text-center transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <span
                className="text-4xl lg:text-5xl font-extralight text-amber-400 mb-3"
              >
                {stat.value}
              </span>
              <span className="text-xs font-light text-gray-400 uppercase tracking-widest leading-relaxed" style={{ letterSpacing: '0.15em' }}>
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
